import { AutocompleteTagInput } from '@ui-components/neo.tax';

import { AutocompleteTagFormType } from './forms.types';

export const AutocompleteTagForm = <OptionType extends Record<string, any>>({
  form,
}: {
  form: AutocompleteTagFormType<OptionType>;
}): React.ReactElement | null => (
  <AutocompleteTagInput
    id={form.id}
    options={form.options}
    values={form.values}
    placeholder={form.placeholder}
    onChange={form.onChange}
    disabled={form.disabled}
    error={!!form.validator?.(form.values)}
    errorText={form.validator?.(form.values)}
    allowCreate={form.allowCreate}
    allowRemove={form.allowRemove}
    isLoading={form.isLoading}
    searchKeyword={form.searchKeyword}
    searchKeywordDebounce={form.searchKeywordDebounce}
    setSearchKeyword={form.setSearchKeyword}
    tagProps={form.tagProps}
  />
);
